import { render, staticRenderFns } from "./usuarios.crud.vue?vue&type=template&id=34b35509"
import script from "./usuarios.crud.vue?vue&type=script&lang=ts"
export * from "./usuarios.crud.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports